var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategorias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_897",
    "data-name": "Rect\\xE1ngulo 897",
    width: 22.565,
    height: 19.762,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Categorias"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Categorias",
    clipPath: "url(#clip-Categorias)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_865",
    "data-name": "Grupo 865",
    transform: "translate(3.718 5.119)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_494",
    "data-name": "Trazado 494",
    d: "M107.369,69.385c-.115.444-.237.887-.343,1.333q-.675,2.846-1.34,5.694a1.682,1.682,0,0,0-.044.369c0,.639,0,1.278,0,1.916,0,.418-.152.567-.573.567q-2.379,0-4.758,0c-.406,0-.558-.154-.561-.557,0-.015,0-.03,0-.044a13,13,0,0,0-.5-4.235c-.433-1.659-.8-3.337-1.189-5.007-.1-.411.068-.633.483-.633q4.152,0,8.3,0a.581.581,0,0,1,.524.292ZM104.765,77h-4.138v1.4h4.138Z",
    transform: "translate(-84.804 -59.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_495",
    "data-name": "Trazado 495",
    d: "M57.554,12.163c0-2.225.012-4.45-.006-6.675a2.545,2.545,0,0,1,1.024-2.263A.318.318,0,0,0,58.652,3c.006-.793,0-1.586,0-2.379,0-.482.133-.615.613-.615.441,0,.881,0,1.322,0,.391,0,.546.154.548.548,0,.815,0,1.63.006,2.445a.363.363,0,0,0,.113.256,2.348,2.348,0,0,1,.982,1.972q.006,7,0,13.99c0,.394-.157.548-.547.548q-1.774,0-3.547,0c-.45,0-.592-.141-.592-.592q0-3.5,0-7.006M60.262.869h-.724V2.826h.724Z",
    transform: "translate(-49.783 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_496",
    "data-name": "Trazado 496",
    d: "M3.222,56.367H1.085c-.5,0-.593-.077-.659-.58A43.384,43.384,0,0,1,0,49.553a18.254,18.254,0,0,1,.942-5.2c.178-.566.4-1.118.6-1.678a.5.5,0,0,1,.516-.361q1.179,0,2.357,0a.507.507,0,0,1,.515.365,20.277,20.277,0,0,1,1.477,5.977,26.058,26.058,0,0,1,0,3.278c-.074,1.318-.24,2.63-.366,3.944-.033.341-.183.485-.525.486-.764,0-1.527,0-2.291,0M1.408,49.434c.033.271.074.687.14,1.1a3.656,3.656,0,0,0,.175.657,3.014,3.014,0,0,0,.763,1.268,1.021,1.021,0,0,0,1.5,0,2.985,2.985,0,0,0,.776-1.309,5.889,5.889,0,0,0,.267-2.365,4.742,4.742,0,0,0-.751-2.336,1.156,1.156,0,0,0-2.057-.036c-.021.03-.039.062-.059.093a5.386,5.386,0,0,0-.751,2.931m3.886,5.272H1.178l.083.793H5.209l.085-.793",
    transform: "translate(0 -36.606)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorias);
export default __webpack_public_path__ + "static/media/Categorias.bc3f27f6b14972919a1273bdbefe6bbf.svg";
export { ForwardRef as ReactComponent };